module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/neck-275477b338981164eb5163c6815cad11.png";